<template>
  <div>
    <footer>
      <div class="laranja">
        <div class="container">
          <strong>Rede de Estudos Rurais</strong>
          <br />
          <br />Avenida Presidente Vargas, 417 – 9º andar – Sala 909
          <br />CEP 20071-003 – Rio de Janeiro – RJ
          <br />
          <br />
          <a href="mailto:redesrurais@redesrurais.org.br">redesrurais@redesrurais.org.br</a>
        </div>
      </div>
      <div class="copy">
        <div class="container">
          Redes de Estudos Rurais © 2022 – Desenvolvido pela
          <a href="http://roxpublicidade.com.br" target="_blank">ROX</a>.
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
   name: "Footer"
};
</script>

<style>
</style>
